import { BlockText, GridContainer, GridItem, iTxt, separatePath } from "@duosoftbg/nacid-components";
import { getI18n } from "react-i18next";
import Box from "@mui/system/Box";
import { buildFetchFileUrl } from "../../../../../../axios/api/services";

const UniversityInfo = ({ university }) => {
  const { relativePath, fileId } = separatePath(university.logoRelativePath);

  return (
    <GridContainer>
      {relativePath && fileId && (
        <GridItem>
          <Box
            component="img"
            sx={{
              maxHeight: { xs: 233, md: 167 },
              maxWidth: { xs: 350, md: 250 },
            }}
            src={buildFetchFileUrl(relativePath, fileId, null)}
          />
        </GridItem>
      )}
      <GridItem md={8}>
        <GridContainer>
          <GridItem sm={12} md={4}>
            <BlockText label={"l.eik"} text={university.id} />
          </GridItem>
          <GridItem sm={12} md={8}>
            <BlockText label={"l.detail.website"} text={university.website} />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem sm={12} md={4}>
            <BlockText label={"l.detail.zipCode"} text={university.zipCode} />
          </GridItem>
          <GridItem sm={12} md={4}>
            <BlockText label={"l.detail.city"} text={university.settlement.fullSettlementName} />
          </GridItem>
          <GridItem sm={12} md={4}>
            <BlockText
              label={"l.detail.address"}
              text={iTxt(getI18n().language, university?.address, university?.addressEn)}
            />
          </GridItem>
        </GridContainer>
      </GridItem>
    </GridContainer>
  );
};
export default UniversityInfo;
